// Import model
import { StartLeadAppointmentSendAppointmentConfirmationEmailRequest } from '../models/StartLeadAppointmentSendAppointmentConfirmationEmailRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartLeadAppointmentSendAppointmentConfirmationEmailRequest - handles JSON serialization and deserialization with type validation
 */
export class StartLeadAppointmentSendAppointmentConfirmationEmailRequestSerializer {
  /**
   * Deserializes a JSON string into a StartLeadAppointmentSendAppointmentConfirmationEmailRequest instance
   */
  static deserialize(json: string): StartLeadAppointmentSendAppointmentConfirmationEmailRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartLeadAppointmentSendAppointmentConfirmationEmailRequest instance
   */
  static fromObject(obj: any): StartLeadAppointmentSendAppointmentConfirmationEmailRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartLeadAppointmentSendAppointmentConfirmationEmailRequest');
    }


    const instance: StartLeadAppointmentSendAppointmentConfirmationEmailRequest = {
      description: obj['Description'] as string | undefined,
      unlayerTemplateId: obj['UnlayerTemplateId'] as string | undefined,
      message: obj['Message'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartLeadAppointmentSendAppointmentConfirmationEmailRequest instances
   */
  static deserializeArray(json: string): StartLeadAppointmentSendAppointmentConfirmationEmailRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartLeadAppointmentSendAppointmentConfirmationEmailRequest instance to a JSON string
   */
  static serialize(instance: StartLeadAppointmentSendAppointmentConfirmationEmailRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartLeadAppointmentSendAppointmentConfirmationEmailRequest instance to a plain object
   */
  static toObject(instance: StartLeadAppointmentSendAppointmentConfirmationEmailRequest): any {
    return {
      'Description': instance.description,
      'UnlayerTemplateId': instance.unlayerTemplateId,
      'Message': instance.message,
    };
  }

  /**
   * Serializes an array of StartLeadAppointmentSendAppointmentConfirmationEmailRequest instances to a JSON string
   */
  static serializeArray(instances: StartLeadAppointmentSendAppointmentConfirmationEmailRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
